(function () {
  if (window.__ondaCartLocation) return;
  window.__ondaCartLocation = true;

  function saveLocation(value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Google Maps location': value } })
    });
  }

  function visibleBox() {
    var boxes = document.querySelectorAll('.cart-location');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].offsetParent !== null) return boxes[i];
    }
    return boxes[0] || null;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.classList && input.classList.contains('cart-location__input')) {
      saveLocation(input.value.trim());
      if (input.value.trim()) {
        var box = input.closest('.cart-location');
        if (box) {
          box.classList.remove('cart-location--invalid');
          var err = box.querySelector('.cart-location__error');
          if (err) err.hidden = true;
        }
      }
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.cart-location__btn') : null;
    if (!button) return;
    event.preventDefault();
    if (!navigator.geolocation) {
      alert('Location is not supported on this device — please paste your Google Maps link instead.');
      return;
    }
    var original = button.textContent;
    button.textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var link = 'https://maps.google.com/?q=' + position.coords.latitude + ',' + position.coords.longitude;
        var wrapper = button.closest('.cart-location');
        var input = wrapper ? wrapper.querySelector('.cart-location__input') : null;
        if (input) {
          input.value = link;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        button.textContent = 'Location added ✓';
      },
      function () {
        button.textContent = original;
        alert('Could not get your location — you can paste a Google Maps link instead.');
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });

  // Block checkout until a location is provided.
  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton = event.target && event.target.closest ? event.target.closest('.cart__checkout-button') : null;
      if (!checkoutButton) return;
      var box = visibleBox();
      if (!box) return;
      var input = box.querySelector('.cart-location__input');
      if (input && input.value.trim() !== '') return;
      event.preventDefault();
      event.stopPropagation();
      box.classList.add('cart-location--invalid');
      var err = box.querySelector('.cart-location__error');
      if (err) err.hidden = false;
      if (input) input.focus();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );
})();
